<template>
  <div class="layout-default relative bg-gray-100" :class="[layoutClass]">
    <!-- 页头 -->
    <DefaultHeader></DefaultHeader>

    <!-- 导航栏 -->
    <div class="bg-primary">
      <TabHeader></TabHeader>
    </div>

    <div class="content">
      <router-view />
    </div>

    <!-- <div class="fzdh" v-if="$route.meta.title == '首页'">
      <h3>山西省首届中药材交易暨党参产业发展大会</h3>
      <img src="@/assets/images/fzdh-logo.png" />
      <router-link to="/yaobo">
        点击前往
        <i></i>
        <i></i>
        <i></i>
      </router-link>
      <a :href="`/yaobo/`" target="_blank">
        点击前往
        <i></i>
        <i></i>
        <i></i>
      </a>
    </div> -->

    <!-- 页脚 -->
    <DefaultFooter></DefaultFooter>

    <el-backtop>
      <div>
        <el-icon class="el-icon-caret-top" />
      </div>
    </el-backtop>
  </div>
</template>

<script>
import DefaultHeader from "../components/Headers/DefaultHeader";
import DefaultFooter from "../components/Footers/DefaultFooter";
import TabHeader from "../components/Headers/TabHeader";
import { Backtop, Icon } from "element-ui";

export default {
  components: {
    DefaultHeader,
    DefaultFooter,
    TabHeader,
    ElBacktop: Backtop,
    ElIcon: Icon,
  },
  data() {
    return {};
  },
  computed: {
    // 基于路线的元数据设置布局元素的类。
    layoutClass() {
      return this.$route.meta.layoutClass;
    },
  },
};
</script>
<style lang="scss" scoped>
.fzdh {
  height: 331px;
  background: url(@/assets/images/fzdh-bg.png) no-repeat center;
  background-size: 100% 100%;
  margin-top: 50px;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 30px;
  transition: all 16120ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-size: 133.983% 133.983%;
  }
  h3 {
    font-size: 32px;
    font-weight: 500;
    color: #000000;
  }
  img {
    width: 229px;
    height: 30px;
    margin: 16px 0 25px;
  }
  a {
    position: relative;
    width: 154px;
    height: 43px;
    background: #458b5b;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 39px;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: transparent;
      border-color: #458b5b;
      color: #458b5b;
      & > i {
        box-shadow: 0 0 10px #458b5b;

        &:nth-child(1) {
          animation: enter 2s linear 0s infinite;
        }
        &:nth-child(2) {
          animation: enter 2s linear 0.75s infinite;
        }
        &:nth-child(3) {
          animation: enter 2s linear 1.5s infinite;
        }
      }
    }

    & > i {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      border-radius: 999px;
      opacity: 0;
    }
  }
}

@keyframes enter {
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.3);
  }
}
</style>
